import React, {useEffect, useState} from "react";
import {connect, useSelector} from "react-redux";
import {getActionIcon, getActionColor, numberWithCommas, formatDateTimeToZone, formatInvoiceAction} from "../common/Helpers";
import IconInvoices from "../iconComponents/IconInvoices";
import IconTrash from "../iconComponents/IconTrash";

export function InvoiceListItem(props) {

const invoice = props.invoice;

const [rowIsHovered, setRowIsHovered] = useState(null);
const [trashIsHovered, setTrashIsHovered] = useState(null);

const overdue = (invoice.payment_days_left !== null) && (invoice.payment_days_left < 1);
const stale = (!invoice.payment_due_date) && (invoice.send_date_days_since > 30) && (invoice.invoice_status !== "Closed");
const late = overdue || stale;
const dateStyle = late ? "tb-text heavy" : "light-black";

// const rowColor = props.responsible ? "p9" : ""
// const rowHoverColor = props.responsible ? "p8c" : "g9";
const backdrop = rowIsHovered ? "g9" : "";



const daysSinceSent = invoice.send_date ? `${invoice.send_date_days_since.toString()} Days Ago` : "-";     // content1 light-black
const dateSent = invoice.send_date ? invoice.send_date : "Not Sent";                           // content2 light     

const daysToDeadline = (invoice.payment_due_date && (invoice.invoice_status === "Active" || invoice.invoice_status === "Pending")) ? `${invoice.payment_days_left?.toString()} Days` : "-"                               // content1 light-black
const deadline = invoice.payment_due_date ? formatDateTimeToZone(invoice.payment_due_date) : (invoice.duration_payment ? `${invoice.duration_payment.toString()} Days after sending` : "No Deadline")     // content2 light

// A Basic-tier company is always exactly one person -- show that person directly
// rather than a company name that doesn't represent a real organization.
const vendorName = invoice.vendor_is_basic
    ? (invoice.vendor_person_name || invoice.vendor_person_email)
    : (invoice.vendor_name ? invoice.vendor_name : "New User");
const purchaserName = invoice.purchaser_is_basic
    ? (invoice.purchaser_person_name || invoice.purchaser_person_email)
    : (invoice.purchaser_name ? invoice.purchaser_name : "New User");


    return (
        <tr 
            key={invoice.invoice_id} 
            className={`table-row ${backdrop}` }
            onClick={() => props.handleSelectInvoiceListItem(invoice.invoice_id, invoice.invoice_status)} 
            onMouseEnter={() => setRowIsHovered(invoice.invoice_id)}
            onMouseLeave={() => setRowIsHovered(null)} >

            <td className={`typical rigid content1 light-black first `} style={{paddingRight: "4px"}} >
                <IconInvoices  height="18px" pathClass="g2-fill"  className="td-icon" />
            </td>
            <td className={`typical flexi content1 light-black `} style={{paddingLeft: "4px"}} >
                <div className="name heavy">{invoice.invoice_number !== "" ? invoice.invoice_number : "-"}</div>
                <div style={{lineHeight: "100%"}} className="content2 light">{invoice.contract_name}</div>
            </td>
            <td className={`typical flexi content1 light-black`} >
                <div style={{lineHeight: "150%"}}>
                    {/* <img className="gap-right-s list-logo iblock" src={invoice.company_vendor_icon_path}  role="presentation" /> */}
                    <span className="heavy-grey">{props.sortByCompany === "Purchaser" ? "P" : "V"}&nbsp;&nbsp;&nbsp;</span>
                    {props.sortByCompany === "Purchaser" ? purchaserName : vendorName}
                </div>
                <div style={{lineHeight: "150%"}}>
                    {/* <img className="gap-right-s list-logo iblock" src={invoice.company_purchaser_icon_path}  role="presentation" /> */}
                    <span className="heavy-grey">{props.sortByCompany === "Purchaser" ? "V" : "P"}&nbsp;&nbsp;&nbsp;</span>
                    {props.sortByCompany === "Purchaser" ? vendorName : purchaserName}
                </div>
            </td>

            <td className={`typical flexi content1 light-black`} >
                <div className={stale ? "heavy tb-text" : ""} >{daysSinceSent}</div>
                <div className="content2 light">{dateSent}</div>
            </td>
            <td className={`typical flexi content1 light-black`} >
                <div className={overdue ? "heavy tb-text" : ""}>{daysToDeadline}</div>
                <div className="content2 light">{deadline}</div>
            </td>

            <td className={`typical flexi content1 light-black`} >
                $ {invoice.total_value? numberWithCommas(invoice.total_value) : "-"}
            </td>
            <td className={`typical rigid content1 light-black last-cell`} >
                <div className="iblock gap-right-xs v-middle" >
                    {getActionIcon(invoice.stage, props.action)}
                </div>
                {formatInvoiceAction(invoice.stage)}
            </td>
        </tr> 
    )
}

const mapStateToProps = () => ({})

export default connect(mapStateToProps)(InvoiceListItem);